import { Link } from 'react-router-dom';
import { siteConfig } from '@/mocks/siteData';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    {
      title: '下载指南',
      links: [
        { label: '安卓下载教程', to: '/article/pg-zhengtu-android-xiazai-jiaocheng' },
        { label: 'iOS下载教程', to: '/article/pg-zhengtu-ios-xiazai-anzhuang' },
        { label: '安装常见问题', to: '/article/pg-zhengtu-anzhuang-changjian-wenti' },
      ],
    },
    {
      title: '游戏攻略',
      links: [
        { label: '新手指南', to: '/category/xinshou-zhinan' },
        { label: '角色培养', to: '/article/pg-zhengtu-jiaose-peiyang-gonglue' },
        { label: '充值返利', to: '/article/pg-zhengtu-chongzhi-fanli' },
      ],
    },
    {
      title: '帮助支持',
      links: [
        { label: '常见问题', to: '/category/changjian-wenti' },
        { label: '账号安全', to: '/article/pg-zhengtu-zhanghao-anquan' },
        { label: '联系我们', to: '/about' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', to: '/about' },
        { label: '最新资讯', to: '/category/zuixin-zixun' },
        { label: '用户评价', to: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-gamepad-line text-lg text-white"></i>
              </div>
              <span className="font-heading font-bold text-lg text-white whitespace-nowrap">
                {siteConfig.name}
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              {siteConfig.tagline}。安全无病毒，正版保障，海量玩家信赖之选。
            </p>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-lg bg-background-800 hover:bg-primary-500 flex items-center justify-center transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading font-semibold text-white mb-4 text-sm">
                {group.title}
              </h4>
              <ul className="flex flex-col gap-2.5">
                {group.links.map((link) => (
                  <li key={link.to}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-500 hover:text-white transition-colors"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-foreground-600">
            &copy; {currentYear} {siteConfig.name} 版权所有 | 本站为PG征途国际官方下载安装指南网站
          </p>
          <div className="flex items-center gap-4 text-sm text-foreground-600">
            <a href="#" className="hover:text-white transition-colors">隐私政策</a>
            <a href="#" className="hover:text-white transition-colors">服务条款</a>
            <a href="#" className="hover:text-white transition-colors">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}